
import React from "react";
import * as Styled from "./TextField.styles";
import { Grid}  from "@mui/material";

export const TextField = ({properties, ...rest}) => {
    console.log(properties);
    return (
    <Styled.Stack direction={'row'} justifyContent={'flex-start'} >
        <Grid container spacing={2} alignItems={'center'}>
            <Grid item xs={2}>   
                <Styled.Label>{properties.label}</Styled.Label>
            </Grid>
            <Grid item xs={10}>   
                <Styled.TextField fullWidth {...rest}>{properties.value}</Styled.TextField>
            </Grid>
        </Grid>      
    </Styled.Stack>)
   
}